import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Container,
  CssBaseline,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  IconButton,
  Card,
  CardContent,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import AddUserModal from './add-user';
import { addUser, fetchUsers } from '../../redux/actions/usersActions';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentUser } from '../../services/authService';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MenuIcon from '@mui/icons-material/Menu';
import { makeStyles } from '@mui/styles';
import { useMediaQuery, useTheme } from '@mui/material';

const useStyles = makeStyles((theme) => ({
  card: {
    width: '300px',
    margin: '16px',
    padding: '16px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
  },
}));

function CollegeDashboard() {
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const dispatch = useDispatch();
  const users = useSelector((state) => state.users.data);
  const loading = useSelector((state) => state.users.loading);
  const error = useSelector((state) => state.users.error);
  const currentUser = getCurrentUser();
  const theme = useTheme();
  const classes = useStyles();

  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (currentUser) {
      dispatch(fetchUsers(currentUser?.uid));
    }
  }, [dispatch, currentUser, currentUser?.uid]);

  if (error) {
    return <div>Error: {error}</div>;
  }

  const handleAddUser = () => {
    setIsAddUserModalOpen(true);
  };

  const handleCloseAddUserModal = () => {
    setIsAddUserModalOpen(false);
  };

  const handleSaveUser = async (newUser) => {
    try {
      await dispatch(addUser(newUser));
      setIsAddUserModalOpen(false);
      toast.success('Utilisateur ajouté avec succès', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
    } catch (error) {
      console.error('Error adding user:', error);
      toast.error("Erreur lors de l'ajout d'un utilisateur", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
    }
  };

  const toggleDrawer = (open) => () => {
    setIsDrawerOpen(open);
  };

  const sideMenu = (
    <div>
      <List>
        <ListItem button onClick={handleAddUser}>
          <ListItemIcon>
            <AddIcon />
          </ListItemIcon>
          <ListItemText primary="Ajouter un élève" />
        </ListItem>
      </List>
    </div>
  );

  return (
    <div>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer(true)}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" style={{ flexGrow: 1 }}>
            College Dashboard
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        anchor="left"
        open={isDrawerOpen}
        onClose={toggleDrawer(false)}
      >
        {sideMenu}
      </Drawer>
      <Container component="main" maxWidth="lg">
        <CssBaseline />
        <div>
          <Typography variant="h4" align="center" gutterBottom>
            College Dashboard
          </Typography>
          {isMobile ? (
            <div>
              {users.map((user) => (
                <Card key={user.id} className={classes.card}>
                  <CardContent>
                    <Typography variant="h6">
                      {user.firstName} {user.lastName}
                    </Typography>
                    <Typography variant="body2">Email: {user.email}</Typography>
                    <Typography variant="body2">Birthday: {user.birthday}</Typography>
                  </CardContent>
                </Card>
              ))}
            </div>
          ) : (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Prénom</TableCell>
                    <TableCell>Nom</TableCell>
                    <TableCell>E-mail</TableCell>
                    <TableCell>Date de naissance</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {users.map((user) => (
                    <TableRow key={user.id}>
                      <TableCell>{user.firstName}</TableCell>
                      <TableCell>{user.lastName}</TableCell>
                      <TableCell>{user.email}</TableCell>
                      <TableCell>{user.birthday}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </div>
      </Container>
      <AddUserModal
        open={isAddUserModalOpen}
        onClose={handleCloseAddUserModal}
        onSave={handleSaveUser}
      />
      <ToastContainer />
      {loading && (
        <div className="loader">
          <div className="loader-spinner"></div>
        </div>
      )}
    </div>
  );
}

export default CollegeDashboard;
